import { invokeHttp } from './api'

export const get = (id) =>
  invokeHttp('/admin/patient/reservation/booking/matching', { id })

export const matchJob = (id, caregiverId) =>
  invokeHttp('/admin/patient/reservation/booking/match', { id, caregiverId })

export const unmatchJob = (id, caregiverId) =>
  invokeHttp('/admin/patient/reservation/booking/unmatch', { id, caregiverId })

export const sendCgProfile = (id, caregiverId) =>
  invokeHttp('/admin/patient/reservation/booking/sendcg', { id, caregiverId })
